module.exports = __webpack_public_path__ + "img/hotel-9.58ab2ad4.jpeg";